import { useTranslation } from "react-i18next";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/backend";
import { Routes } from "@/lib/router";
import { logger } from "@/logger";

export function useSwitchOrganization() {
  const { t } = useTranslation();

  return useMutation({
    mutationKey: ["organization", "switch"],
    mutationFn: async (organizationId: string) => {
      const response = await api.api.switchOrganization(
        { organizationId },
        {
          credentials: "include", // Ensure cookies are sent
        },
      );
      return response.data;
    },
    onSuccess: () => {
      // IMPORTANT: Force full page reload instead of using query invalidation
      // After switching organizations, the nested IonRouterOutlet stack can become corrupted,
      // causing navigation issues and ion-page-invisible to stick on iOS.
      // A hard reload ensures the entire router state and all queries are properly reset
      // with the new organization context.
      toast.success(t("common:settings.organization.switch.success"));

      // Small delay to show the toast before reload
      setTimeout(() => {
        window.location.href = Routes.Projects();
      }, 500);
    },
    onError: (error) => {
      toast.error(t("common:settings.organization.switch.error"));
      logger.error({ error }, "Failed to switch organization");
    },
  });
}
